import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'
import Typography from '@/ui/components/typography'
import { SegmentLocation } from './Segment.types'

export const SegmentContainer = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    position: relative;
    flex: 1;
`

export const SegmentBar = styled('div')<{
    color: string
    isSelected: boolean
    location: SegmentLocation
    theme?: TTheme
}>`
    width: 100%;
    height: 12px;
    background-color: ${({ color }) => color};
    opacity: ${({ isSelected }) => (isSelected ? 1 : 0.3)};
    border-radius: ${({ location }) => {
        if (location === 'start') {
            return '167px 0 0 167px'
        }
        if (location === 'end') {
            return '0 167px 167px 0'
        }
        return '0'
    }};
`

export const SegmentText = styled(Typography)`
    text-align: center;
`

export const SegmentArrow = styled('div')<{
    color: string
    isSelected: boolean
}>`
    display: ${({ isSelected }) => (isSelected ? 'block' : 'none')};
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid ${({ color }) => color};
`
